import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { createAuthService } from '../services/authService';
import logoImg from '../img/newlogo.png';

function OperatorAuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const checkEmailInStorage = async () => {
            const storedEmail = window.localStorage.getItem('emailForSignIn');
            if (storedEmail) {
                await handleSignIn(storedEmail);
            } else {
                setIsLoading(false);
            }
        };

        checkEmailInStorage();
    }, []);

    const handleSignIn = async (emailToUse) => {
        try {
            setIsLoading(true);
            setError(null);
            const authService = await createAuthService();
            const fullUrl = window.location.href;
            const params = new URLSearchParams(location.search);
            const mode = params.get('mode');
            const oobCode = params.get('oobCode');

            if (mode === 'signIn' && emailToUse && oobCode) {
                await authService.signInWithEmailLinkMethod(emailToUse, fullUrl);
                window.localStorage.removeItem('emailForSignIn');
                navigate('/home');
            } else {
                throw new Error('Link inválido');
            }
        } catch (error) {
            console.error('Error en la autenticación:', error);
            let errorMessage = '';

            // Manejar diferentes tipos de errores
            switch (error.code) {
                case 'auth/invalid-action-code':
                    errorMessage = 'Este link de acceso ya ha sido utilizado o ha expirado. Por favor, solicita un nuevo link de acceso al administrador.';
                    break;
                case 'auth/invalid-email':
                    errorMessage = 'El email ingresado no coincide con el email al que se envió el link de acceso.';
                    break;
                default:
                    errorMessage = 'Error al verificar el acceso. Por favor, verifica tu email e intenta nuevamente.';
            }

            setError(errorMessage);
            window.localStorage.removeItem('emailForSignIn');
            setIsLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            setError('Por favor, ingresa tu email');
            return;
        }
        window.localStorage.setItem('emailForSignIn', email);
        await handleSignIn(email);
    };

    const handleBackToLogin = () => {
        navigate('/login');
    };

    if (isLoading) {
        return (
            <div className="login-container">
                <div className="login-card">
                    <img src={logoImg} alt="Logo" className="login-logo" />
                    <h2>Verificando acceso...</h2>
                    <p>Por favor espera mientras verificamos tu acceso...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="login-container">
            <div className="login-card">
                <img src={logoImg} alt="Logo" className="login-logo" />
                <h2>Confirma tu identidad</h2>
                <form onSubmit={handleSubmit} className="login-form">
                    <input
                        type="email"
                        placeholder="Ingresa tu email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="login-input"
                        required
                    />
                    <button type="submit" className="login-button">
                        Verificar acceso
                    </button>
                    {error && (
                        <div className="error-message">
                            <p>{error}</p>
                            {error.includes('expirado') && (
                                <button
                                    onClick={handleBackToLogin}
                                    type="button"
                                    className="login-button"
                                    style={{ marginTop: '10px' }}
                                >
                                    Volver al inicio de sesión
                                </button>
                            )}
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
}

export default OperatorAuthCallback; 